{
  "back": "Back",
  "share": "Share"
}
